import { createClient } from '@supabase/supabase-js'
import type { Database } from '@psn/db'
import { env } from '../env'

export const supabase = createClient<Database>(
  env.supabaseUrl,
  env.supabaseAnonKey
)
